import { Component, OnInit, Input } from '@angular/core';
import { Statement } from '../../models/accounting/statement';

@Component({
  standalone: false,
  selector: 'app-entry-account-statement',
  templateUrl: './entry-account-statement.component.html',
styleUrls:  ['./entry-account-statement.component.css']
})
export class EntryAccountStatementComponent implements OnInit {

  @Input() statement: Statement;
  @Input() credit_prize_money: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
